import clsx from 'clsx'
import { rem } from 'polished'
import { useRef, useState } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'

import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import TextLink from 'LuxKit/TextLink'
import { useElementHeight } from 'hooks/useElementSize'

const Container = styled.div`
  position: relative;
  overflow: hidden;
  transition: max-height 0.2s;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    inset-inline: 0;
    height: ${rem(32)};
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;
  }

  &.show-mask::after {
    opacity: 1;
  }
`

interface Props {
  text?: string
  children?: React.ReactNode
}

function ShowMore(props: Props) {
  const intl = useIntl()
  const defaultText = intl.formatMessage({
    id: 'oHSJNs2DzNF7yLW2-Rwc',
    defaultMessage: 'Add additional details',
    description: 'Default display text for show more link in the trip planner item editor modal',
  })
  const { text = defaultText, children } = props
  const [expandedDetails, setExpandedDetails] = useState(false)

  const contentElement = useRef<HTMLDivElement>(null)
  const contentHeight = useElementHeight(contentElement) ?? 0

  return (
    <>
      <TextLink
        onClick={() => {
          setExpandedDetails((prev) => !prev)
        }}
        endIcon={
          <DropdownChevron direction={expandedDetails ? 'up' : 'down'} />
        }
      >
        {text}
      </TextLink>
      <Container
        className={clsx({ 'show-mask': !expandedDetails })}
        style={{
          maxHeight: expandedDetails ? contentHeight : 0,
        }}
      >
        <div ref={contentElement}>{children}</div>
      </Container>
    </>
  )
}

export default ShowMore
